/**
 * Maps Olympus resource names to auth-service resource names.
 * NOTE: This list must be kept in sync with similar lists found in other files.
 * See apps/auth-service/README.md ("Important: Update resource constants...")
 * for more detail.
 */
export const olympusResourceToNewResource = {
    actions: 'actions',
    billing: 'billing',
    brands: 'brand',
    careers: 'career',
    carts: 'cart',
    'checkout-settings': 'checkout-settings',
    coupons: 'coupon',
    'customer-io-syncs': 'customer-io-sync',
    customers: 'customer',
    delivery: 'delivery',
    devices: 'device',
    dispute: 'dispute',
    domains: 'domain',
    employment: 'employment',
    events: 'event',
    'fee-settings': 'fee-settings',
    forms: 'form',
    funnels: 'funnel',
    generator: 'generator',
    'gift-cards': 'gift-card',
    'gift-card.order': 'gift-card.order',
    'google-search-console': 'google-search-console',
    heartbeats: 'heartbeat',
    'inbox.message': 'inbox.message',
    'inbox.thread': 'inbox.thread',
    integrations: 'integrations',
    jobs: 'job',
    'job-applications': 'job-application',
    keywords: 'keyword',
    legal: 'legal',
    listings: 'listing',
    locations: 'location',
    marketing: 'marketing',
    marketplace: 'marketplace',
    menu: 'menu',
    mobileApp: 'mobile-app',
    onboarding: 'onboarding',
    orders: 'order',
    'ownership-groups': 'ownership-group',
    'partner-referrals': 'partner-referral',
    'payment-account': 'payment-account',
    payout: 'payout',
    'physical-media': 'physical-media',
    reports: 'reports',
    relay: 'relay',
    reviews: 'review',
    sessions: 'session',
    'scout.research': 'scout.research',
    'scout.website': 'scout.website',
    seo: 'seo',
    'smart-coupons': 'smart-coupon',
    stations: 'station',
    templates: 'template',
    users: 'user',
    voice: 'voice',
    webhooks: 'webhook',
};
//# sourceMappingURL=olympus.scopes.js.map